import React from 'react'
import { Loader } from '../../assets/icons'

interface IProps {
    type?: 'button' | 'submit' | 'reset' | undefined
    onClick?: () => void
    placeholder: string
    isLoading?: boolean
    disabled?: boolean
}

export default function Button(props: IProps): React.ReactElement {
    return (
        <button type={props.type} onClick={props.onClick} className={`button-primary ${props.disabled ? 'disabled' : ''}`}>
            {!props.isLoading ? props.placeholder : <Loader />}
        </button>
    )
}
